module.exports = __webpack_public_path__ + "wave-drawer-glitched-33467bf8c8d2b995d6c76d8810aba3db.png";